<div
  class="tw:flex tw:flex-col tw:h-screen tw:transition-[width] tw:duration-300 tw:ease-in-out"
  [ngStyle]="{
    width: collapsed() && !showAsOverlay() ? '3.6rem' : '18rem',
  }">
  <!-- Header Starts -->
  <div
    class="tw:flex tw:justify-center tw:items-center tw:py-2"
    [ngClass]="{
      'tw:px-3': !collapsed() || showAsOverlay(),
    }">
    <!-- Company Logo -->
    @if (!collapsed() || showAsOverlay()) {
      <div class="tw:flex tw:flex-1 tw:items-center tw:justify-between tw:flex-wrap tw:gap-2">
        <a
          test-id="sidebar-nav-img"
          routerLink="/home"
          class="tw:block">
          <img
            class="tw:max-h-[2.2rem]"
            alt="GenGuardX"
            [src]="
              themeService.isDark()
                ? 'assets/images/brand/logo-light.svg'
                : 'assets/images/brand/logo-dark.svg'
            " />
        </a>
        <span class="tw:text-color tw:font-bold tw:whitespace-nowrap">
          {{ appConfigService.appConfig().name }}
        </span>
      </div>
    } @else {
      <div class="tw:flex tw:items-center tw:justify-center">
        <a
          test-id="sidebar-nav-img-2"
          routerLink="/home">
          <img
            class="tw:h-[1.95rem]"
            alt="GenGuardX"
            [src]="
              themeService.isDark()
                ? 'assets/images/brand/logo-small-light.svg'
                : 'assets/images/brand/logo-small-dark.svg'
            " />
        </a>
      </div>
    }
    @if (showAsOverlay()) {
      <p-button
        test-id="sidebar-nav-close"
        [buttonProps]="{ autofocus: false }"
        severity="secondary"
        type="button"
        variant="text"
        size="small"
        pTooltip="Close"
        position="right"
        (click)="onClose.emit()"
        icon="pi pi-times" />
    } @else {
      <!-- NOTE: We add height same as the logo so the layout don't shift -->
      <p-button
        test-id="sidebar-nav-collapse-sidebar"
        [buttonProps]="{ autofocus: false }"
        styleClass="tw:px-0 py-1 tw:border tw:border-surface"
        [style]="{
          '--p-button-sm-icon-only-width': '1.8rem',
        }"
        severity="secondary"
        size="small"
        [pTooltip]="collapsed() ? 'Expand Sidebar' : 'Collapse Sidebar'"
        position="right"
        [ngClass]="{ 'tw:absolute tw:z-11 tw:left-[2.6rem] tw:top-[2.6rem]': collapsed() }"
        [icon]="collapsed() ? 'pi pi-chevron-right' : 'pi pi-chevron-left'"
        (click)="toggleCollapsing()" />
    }
  </div>
  <!-- Header Ends -->
  @if (!collapsed() || showAsOverlay()) {
    <div
      class="tw:rounded-xl tw:border tw:border-surface tw:bg-(--p-content-background) tw:mt-2 tw:mx-2">
      <div
        test-id="sidebar-nav-project-list-toggle"
        class="tw:flex tw:items-center tw:gap-3 tw:p-2 tw:text-left tw:transition tw:duration-200 tw:cursor-pointer"
        (click)="projectList.toggle($event)">
        <p-tag
          class="tw:w-9 tw:h-9 tw:gap-0"
          style="--p-tag-icon-size: 1.1rem"
          icon="pi pi-box tw:text-primary" />
        <div class="tw:flex tw:flex-col tw:flex-1 tw:min-w-0">
          <div class="tw:text-balance tw:text-xs tw:text-primary tw:font-bold">PROJECT</div>
          <div class="tw:truncate tw:font-medium">
            {{ projectList.selectedProject()?.name || 'All Projects' }}
          </div>
        </div>
      </div>
      @if (project.currentProject()) {
        <div class="tw:border-t tw:border-surface tw:p-1">
          <div
            class="tw:flex tw:items-center"
            [pTooltip]="collapsed() && !showAsOverlay() ? 'Home' : undefined"
            position="right">
            <a
              test-id="sidebar-nav-on-close-emit"
              class="tw:w-full tw:flex tw:items-center tw:gap-2 tw:py-2 tw:px-3 tw:rounded tw:hover:bg-primary/20 tw:cursor-pointer"
              [ngClass]="{
                'tw:p-2.5! tw:justify-center': collapsed() && !showAsOverlay(),
              }"
              [routerLink]="`/${project.currentProject()}`"
              routerLinkActive="tw:text-primary! tw:bg-highlight-emphasis"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="onClose.emit()">
              <i class="pi pi-home"></i>
              @if (!collapsed() || showAsOverlay()) {
                <span class="tw:grow tw:shrink-0 tw:font-medium">Project Home</span>
              }
            </a>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="tw:flex tw:justify-center tw:mt-2">
      <p-tag
        class="tw:w-9 tw:h-9 tw:gap-0"
        style="--p-tag-icon-size: 1.25rem"
        severity="secondary"
        icon="pi pi-box tw:text-primary"
        [pTooltip]="
          projectList.selectedProject()?.name
            ? `Project: ${projectList.selectedProject()?.name}`
            : 'All Projects'
        "
        position="right"
        (click)="projectList.toggle($event)" />
    </div>
  }
  <cor-project-list
    #projectList
    (projectSelected)="project.onSelect($event)" />
  <div
    #scrollContainer
    class="tw:flex-1 tw:flex tw:flex-col tw:flex-1 tw:gap-2 tw:p-2 tw:overflow-y-auto tw:overflow-x-hidden tw:pt-2 tw:[scrollbar-width:thin]">
    @if (collapsed() && !showAsOverlay() && project.currentProject()) {
      <div
        class="tw:flex tw:items-center"
        pTooltip="Project Home"
        position="right">
        <a
          test-id="sidebar-nav-on-close-emit-2"
          class="tw:w-full tw:flex tw:items-center tw:gap-2 tw:p-2.5! tw:justify-center tw:rounded tw:hover:bg-primary/20 tw:cursor-pointer"
          [routerLink]="`/${project.currentProject()}`"
          routerLinkActive="tw:text-primary! tw:bg-highlight-emphasis"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="onClose.emit()">
          <i class="pi pi-home"></i>
        </a>
      </div>
    }

    @for (card of cards(); track $index; let last = $last) {
      <div
        [attr.test-id]="'sidenav-item-' + card.name"
        class="tw:flex tw:flex-col tw:gap-1">
        @if (!collapsed() || showAsOverlay()) {
          <span
            class="tw:grow tw:shrink-0 tw:font-semibold tw:text-xs tw:text-muted-color tw:pt-2 tw:uppercase">
            {{ card.name }}
          </span>
        }

        <ng-template
          #tabLink
          let-tab>
          <div
            class="tw:flex tw:items-center"
            [pTooltip]="collapsed() ? tab.name : tab.tooltip"
            [attr.test-id]="'sidenav-item-tab-' + tab.name"
            position="right">
            @if (!tab.isExternalLink) {
              <a
                test-id="sidebar-nav-on-close-emit-3"
                class="tw:w-full tw:flex tw:items-center tw:gap-2 tw:py-2 tw:px-3 tw:rounded tw:hover:bg-primary/20 tw:cursor-pointer"
                [ngClass]="{
                  'tw:p-2.5! tw:justify-center': collapsed() && !showAsOverlay(),
                }"
                [routerLink]="tab.path"
                [routerLinkActive]="['tw:text-primary!', 'tw:bg-highlight-emphasis']"
                (click)="onClose.emit()"
                [queryParams]="tab.queryParameters ? tab.queryParameters : null">
                @if (tab.icon) {
                  <i [ngClass]="tab.icon"></i>
                }
                @if (!collapsed() || showAsOverlay()) {
                  <span class="tw:grow tw:shrink-0 tw:font-medium">
                    {{ tab.name }}
                  </span>
                }
              </a>
            } @else {
              <a
                test-id="sidebar-nav-on-click"
                class="tw:w-full tw:flex tw:items-center tw:gap-2 tw:py-2 tw:px-3 tw:rounded tw:hover:bg-primary/20 tw:cursor-pointer"
                [ngClass]="{
                  'tw:p-2.5! tw:justify-center': collapsed() && !showAsOverlay(),
                }"
                (click)="tab.onClick()"
                target="_blank">
                <i class="pi pi-link"></i>

                @if (!collapsed() || showAsOverlay()) {
                  <span class="tw:grow tw:shrink-0 tw:font-medium">
                    {{ tab.name }}
                  </span>
                }
              </a>
            }
          </div>
        </ng-template>

        @let hasHiddenTab = card.tabs.some(tab => tab.visible && tab.hidden);
        @for (tab of card.tabs; track tab.name) {
          @if (tab.visible && !tab.hidden) {
            <ng-container
              [ngTemplateOutlet]="tabLink"
              [ngTemplateOutletContext]="{ $implicit: tab }" />
          }
        }
        @if (hasHiddenTab) {
          <p-inplace
            class="tw:w-full"
            [pt]="{
              display: { class: 'tw:p-0! tw:rounded-none! tw:bg-transparent!' },
              content: { class: 'tw:p-0!' },
            }">
            <ng-template #display>
              <p-button
                test-id="sidebar-nav-show-all-assets"
                [buttonProps]="{ autofocus: false }"
                [label]="collapsed() && !showAsOverlay() ? undefined : 'Show all assets'"
                ariaLabel="Show all assets"
                severity="secondary"
                icon="pi pi-angle-down"
                variant="text"
                class="tw:p-0"
                [pTooltip]="collapsed() && !showAsOverlay() ? 'Show all assets' : undefined"
                position="right"
                fluid />
            </ng-template>
            <ng-template
              #content
              let-closeCallback="closeCallback">
              <div class="tw:w-full tw:flex tw:flex-col tw:gap-1">
                @for (tab of card.tabs; track tab.name) {
                  @if (tab.visible && tab.hidden) {
                    <ng-container
                      [ngTemplateOutlet]="tabLink"
                      [ngTemplateOutletContext]="{ $implicit: tab }" />
                  }
                }
                <p-button
                  test-id="sidebar-nav-show-less-assets"
                  [buttonProps]="{ autofocus: false }"
                  [label]="collapsed() && !showAsOverlay() ? undefined : 'Show less'"
                  ariaLabel="Show less assets"
                  severity="secondary"
                  icon="pi pi-angle-up"
                  variant="text"
                  [pTooltip]="collapsed() && !showAsOverlay() ? 'Show less assets' : undefined"
                  position="right"
                  (click)="closeCallback($event)" />
              </div>
            </ng-template>
          </p-inplace>
        }

        @if (!last && collapsed() && !showAsOverlay()) {
          <p-divider [style]="{ '--p-divider-horizontal-margin': '0.5rem 0' }" />
        }
      </div>
    }
  </div>
  @if (tourService.isLearningHubEnabled()) {
    <div class="tw:bg-(--p-content-background) tw:border-t tw:border-surface">
      <button
        type="button"
        test-id="sidenav-learning-hub"
        aria-label="Learning Hub"
        class="tw:w-full tw:flex tw:items-center tw:gap-2 tw:py-2 tw:px-3 tw:rounded tw:border-0 tw:bg-transparent tw:text-left tw:hover:bg-primary/20 tw:cursor-pointer"
        [ngClass]="{
          'tw:p-2.5! tw:justify-center': collapsed() && !showAsOverlay(),
        }"
        pTooltip="Learning Hub"
        position="right"
        (click)="learningHubService.openDialog(); onClose.emit()">
        <i class="pi pi-graduation-cap"></i>
        @if (!collapsed() || showAsOverlay()) {
          <span class="tw:grow tw:shrink-0 tw:font-medium">Learning Hub</span>
        }
      </button>
    </div>
  }
  <div
    [ngClass]="{
      'tw:flex tw:justify-center tw:bg-(--p-content-background) tw:border-t tw:border-surface':
        collapsed() && !showAsOverlay(),
    }">
    <cor-profile-popover [avatar]="collapsed() && !showAsOverlay()" />
  </div>
</div>
